import { Formik } from 'formik';
import { Props } from './types';
import * as Styled from './styled';

function Form<Values>({
  className,
  children,
  show,
  autoComplete,
  validateOnBlur,
  height,
  ...props
}: Props<Values>) {
  return (
    <Formik {...props} validateOnMount validateOnBlur={validateOnBlur}>
      {(formikProps) => (
        <Styled.Forms
          autoComplete={autoComplete}
          $show={show}
          $height={height}
          className={className}
          aria-label={props['aria-label']}
          aria-labelledby={props['aria-labelledby']}
        >
          {typeof children === 'function' ? children(formikProps) : children}
        </Styled.Forms>
      )}
    </Formik>
  );
}

Form.defaultProps = {
  show: true,
  autoComplete: 'off',
  validateOnBlur: true,
};

export default Form;
